import Collection from '../collection';
import Form from './form';
import Grid from './grid';
import View from './view';

import { switchKeyboardLayout } from '../utils/strings';
import { hashify, } from '../utils/arrays';





export default Form.extend( {

    initialize(options = {}) {
        Form.prototype.initialize.call( this, options );

        const clusters = hashify( options.clusters, cluster => [cluster.id, cluster] );
        this.options.collection = new Collection( this.options.collection
            .toJSON()
            .map( ({ id, cluster_id, cluster, ...attrs }) => ({
                ...attrs,
                id: +id,
                cluster: cluster || clusters[cluster_id]
            }) )
            .filter( ({ cluster }) => 
                !cluster ||
                !options.cluster ||
                cluster.id == options.cluster.id ) );
                
        options.sorted = new Collection();
        options.filtered = new Collection();
        options.resulted = new Collection();

        const { collection, } = options;
        this.sorted_ = sort( { sort: this.sort_, direction: this.direction_, }, 
            collection, options.sorted, );
    },

    template: 'pick.modal',

    search_: '',

    page_: 1,

    sort_: 'title',

    direction_: 'asc',

    viewMode_: 'all',

    serialize() {
        return this.sorted_.then( () => {
            reRenderGrid.call( this );

            return {
                filtered: this.options.filtered,
                searchString: this.search_, 
                sort: this.sort_,
                direction: this.direction_,
                viewMode: this.viewMode_,
                hasClusters: this.options.collection.models
                    .some( model => model.get( 'cluster' ) )
            };
        } );
    },

    events: {

        'click .-sort'({ currentTarget }) {
            const { sort: sortField, direction, } = currentTarget.dataset;
            const { collection, sorted, } = this.options;

            return this.page_ = 1, this.direction_ = direction, this.sort_ = sortField,
                sort( { sort: this.sort_, direction: this.direction_, }, collection, sorted, )
                    .then( () => reRenderGrid.call( this ) )
                    // hack: to rerender grid caption with order direction
                    .then( () => this.render() )
                    .then( () => this.focus() );
        },

        'click .-toggle-selected'({ currentTarget }) {
            const { id } = currentTarget.dataset;
            const { filtered, } = this.options;

            const needAppend = currentTarget.checked;
            const oldSelected = this.model.get( 'selected' );
            const newSelected = needAppend
                ? [...oldSelected, { id }]
                : oldSelected.filter( item => item.id != id );

            this.model.set( 'selected', newSelected );

            const ids = hashify( newSelected.map( el => el.id ) );
            this.$( '.-toggle-all' )[0].checked = filtered.every( el => ids[el.id] );

            this.focus();
        },

        'click .-toggle-all'({ currentTarget }) {
            const value = currentTarget.checked;
            const { filtered } = this.options;

            const h = hashify( filtered.models.map( el => el.id ) );
            const drained = this.model.get( 'selected' )
                .filter( el => !h[el.id] );

            this.model.set( 'selected', value
                ? [...drained, ...filtered.models]
                : [...drained] );

            this.$( '.-toggle-selected' ).prop( 'checked', value );

            this.focus();
        },

    },

    [View.event('Grid:action:default')](index) {
        this.$( '[name="Grid"] tbody tr' )
            .eq( index ).find( '[type="checkbox"]' ).click();
        this.Grid.focus();
    },

    [View.event( 'toggle-mode' )](mode) {
        if (this.viewMode_ === mode) return;

        return this.viewMode_ = mode, this.page_ = 1,
            this.render().then( () => this.focus() );
    },

    [View.event( 'Paging:page')](page) {
        return this.page_ = +page, 
            reRenderGrid.call( this ),
            this.focus();
    },

    [View.event( 'Search:search')](search) {
        return this.search_ = search, this.page_ = 1,
            reRenderGrid.call( this );
    },

}, {

    of(collection, clusters, cluster) {
        const Class = this;
        return new Class( {
            clusters, cluster,
            collection: collection instanceof Collection
                ? collection
                : new Collection( collection )
        } );
    },

} );





function reRenderGrid() {
    const { sorted, filtered, resulted } = this.options;
    filter.call( this, 
        { search: this.search_, page: this.page_, limit: 10, show: this.viewMode_ }, 
        sorted, filtered, resulted );
}

function sort(params, source, dest) {
    const { sort, direction } = params;
    const props = 'title' === sort
        ? ['name', 'title', 'no', 'id']
        : [sort, 'no', 'id'];

    return Grid.sort( { sort: props, direction }, source, dest );
}

function filter({ search, page, limit, show }, source, filtered, dest) {
    const searchString = search.toLowerCase();
    const hash = hashify( this.model.get( 'selected' )
        .map( ({ id }) => id ) );

    const models = source.toJSON()
        .filter( model => 'all' === show || hash[model.id] )
        .filter( model => ~(model.id + '').indexOf( searchString )
            || ~(model.title || model.name || '').toLowerCase()
                    .indexOf( searchString ) 
            || ~(model.title || model.name || '').toLowerCase()
                    .indexOf( switchKeyboardLayout( searchString ) ) );

    dest.total = filtered.total = models.length;
    dest.page = filtered.page = page;
    dest.limit = filtered.limit = limit;
    
    filtered.reset( models );
    dest.reset( models
        .filter( (_, index) => index >= limit * (page - 1) &&
                               index <  limit * page ) );
}


// WEBPACK FOOTER //
// ./src/js/view/pick.modal.js